import Card from '@packages/ui/card/card.tsx';
import CardHeader from '@packages/ui/card/card-header.tsx';
import CardContent from 'ui/src/card/card-content';
import { useTranslate } from '@tolgee/react';
import TextInput from '@packages/ui/form/input/text-input.tsx';
import FormItem from '@packages/ui/form/form-item.tsx';
import { Controller, useFormContext } from 'react-hook-form';
import { CompanyForm } from '@client/page/management/company-settings/company-settings.tsx';
import FormLayout from '@packages/ui/form/form-layout.tsx';

export default function CompanySocialSetting() {
  const { t } = useTranslate();

  const {
    control,
    formState: { errors },
  } = useFormContext<CompanyForm>();

  // const onSubmit = async (updateData: CompanyUpdateInput) => {
  //   try {
  //     const result = await updateCompanyProfile({
  //       variables: {
  //         companyID: companyID,
  //         input: {
  //           name: data.company?.name ?? '',
  //           instagramLink: updateData.instagramLink,
  //           facebookLink: updateData.facebookLink,
  //           googleLink: updateData.googleLink,
  //           tiktokLink: updateData.tiktokLink,
  //         },
  //       },
  //     });
  //     if (result.data) {
  //       showAlert({
  //         status: 'success',
  //         title: t('company.setting.social.update.alert.title', 'Update Success'),
  //         message: t('company.setting.social.update.alert.message', 'Update social successfully'),
  //       });
  //       location.reload();
  //     }
  //   } catch (err) {
  //     if (err instanceof ApolloError) {
  //       const applicationErrors = formatGraphQlError(err.graphQLErrors);
  //       const validationError = validationErrors(applicationErrors);
  //       for (const field in validationError) {
  //         setError(
  //           field as keyof CompanyUpdateInput,
  //           {
  //             type: 'server',
  //             message: t(validationError[field] ?? 'validation-error.common.alert'),
  //           },
  //           { shouldFocus: true }
  //         );
  //       }
  //     }
  //     captureException(err);
  //   }
  // };

  return (
    <Card>
      <CardHeader title={'Social setting'} />

      <CardContent>
        <FormLayout>
          {/*Instagram*/}
          <FormItem className="max-w-xl" title={t('company.social-setting.form-input.instagram.title', 'Instagram')}>
            <Controller
              name={'instagramLink'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="instagram"
                  value={field.value ?? ''}
                  name="instagram"
                  error={errors.instagramLink?.message}
                  placeholder={t('company.social-setting.form-input.instagram.placeholder', 'https://')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>

          {/*Facebook*/}
          <FormItem className="max-w-xl" title={t('company.social-setting.form-input.facebook.title', 'Facebook')}>
            <Controller
              name={'facebookLink'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="facebook"
                  value={field.value ?? ''}
                  name="facebook"
                  error={errors.facebookLink?.message}
                  placeholder={t('company.social-setting.form-input.facebook.placeholder', 'https://')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>

          {/*Google*/}
          <FormItem className="max-w-xl" title={t('company.social-setting.form-input.google.title', 'Google')}>
            <Controller
              name={'googleLink'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="google"
                  value={field.value ?? ''}
                  name="google"
                  error={errors.googleLink?.message}
                  placeholder={t('company.social-setting.form-input.google.placeholder', 'https://')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>

          {/*Tiktok*/}
          <FormItem className="max-w-xl" title={t('company.social-setting.form-input.tiktok.title', 'Tiktok')}>
            <Controller
              name={'tiktokLink'}
              control={control}
              render={({ field }) => (
                <TextInput
                  type="text"
                  label="tiktok"
                  value={field.value ?? ''}
                  name="tiktok"
                  error={errors.tiktokLink?.message}
                  placeholder={t('company.social-setting.form-input.tiktok.placeholder', 'https://')}
                  onChange={field.onChange}
                />
              )}
            />
          </FormItem>
        </FormLayout>
      </CardContent>
    </Card>
  );
}
